import {createApp} from 'vue'
import GroupDetails from './GroupDetails'

const el = '.kb-component--group-details'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((GroupDetailsDOM) => {
            const props = {
                id: GroupDetailsDOM.dataset.id,
                svgIcon: GroupDetailsDOM.dataset.svgIcon,
                colorTheme: GroupDetailsDOM.dataset.colorTheme,
                title: GroupDetailsDOM.dataset.title,
                type: GroupDetailsDOM.dataset.type,
                updates: GroupDetailsDOM.dataset.updates ? parseInt(GroupDetailsDOM.dataset.updates) : 0,
                numberOfMembers: GroupDetailsDOM.dataset.numberOfMembers ? parseInt(GroupDetailsDOM.dataset.numberOfMembers) : 0,
                numberOfPosts: GroupDetailsDOM.dataset.numberOfPosts ? parseInt(GroupDetailsDOM.dataset.numberOfPosts) : 0,
                link: GroupDetailsDOM.dataset.link
            }
            const component = createApp(GroupDetails, props).use(Store)
            component.mount(GroupDetailsDOM)
        })
    }
}